function ariaExpanded(button) {
  const isExpanded = button.getAttribute('aria-expanded') === 'true';
  button.setAttribute('aria-expanded', String(!isExpanded));
}

function checkAccordionItems(accordions) {
  accordions.forEach((accordion, idx) => {
    const header = accordion.querySelector(
      '.accordion-item__header, .icon-accordion-item__header'
    );
    const panel = accordion.querySelector(
      '.accordion-item__panel, .icon-accordion-item__panel'
    );

    if (!header || !panel) return;

    header.addEventListener('click', () => {
      // Close all other accordions
      accordions.forEach((otherAccordion, otherIdx) => {
        if (otherIdx !== idx) {
          const otherHeader = otherAccordion.querySelector(
            '.accordion-item__header, .icon-accordion-item__header'
          );
          const otherPanel = otherAccordion.querySelector(
            '.accordion-item__panel, .icon-accordion-item__panel'
          );
          if (otherHeader && otherPanel) {
            otherHeader.setAttribute('aria-expanded', 'false');
            otherPanel.style.maxHeight = null;
            otherPanel.hidden = true;
          }
        }
      });

      ariaExpanded(header);
      const expanded = header.getAttribute('aria-expanded') === 'true';

      if (expanded) {
        panel.hidden = false;
        panel.style.maxHeight = `${panel.scrollHeight}px`;
      } else {
        panel.style.maxHeight = null;
        panel.hidden = true;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const allAccordions = document.querySelectorAll('.accordion-item, .icon-accordion-item');
  if (allAccordions.length > 0) {
    checkAccordionItems(allAccordions);
  }
});

document.addEventListener("DOMContentLoaded", function() {
    const hash = window.location.hash.substring(1);
    if (!hash) return;

    const item = document.getElementById(hash);
    if (!item) return;

    const button = item.querySelector(".icon-accordion-item__header");
    const panel = item.querySelector(".icon-accordion-item__panel");

    if (button && panel && panel.hasAttribute("hidden")) {
        panel.removeAttribute("hidden");
        button.setAttribute("aria-expanded", "true");
    }
});